import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full" }
const _hoisted_2 = { class: "w-full relative mt-1 mr-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-3 left-6 text-regular icon icon-search" }, null, -1)
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        class: "w-full bg-white rounded py-2 px-12 border placeholder:opacity-100 placeholder:text-gray-500",
        placeholder: _ctx.translatedPlaceholder,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('searchUpdate', _ctx.search))),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (this.$emit('searchAction')), ["enter"]))
      }, null, 40, _hoisted_4), [
        [_vModelText, _ctx.search]
      ]),
      (_ctx.search.length)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "absolute top-3.5 right-6 text-regular text-gray-500 icon icon-cross cursor-pointer",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetSearch && _ctx.resetSearch(...args)))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_default_button, {
      class: "w-full md:w-auto mt-1",
      type: "outline",
      isLoading: _ctx.isLoading,
      onClick: _cache[4] || (_cache[4] = ($event: any) => (this.$emit('searchAction')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("general.search")), 1)
      ]),
      _: 1
    }, 8, ["isLoading"])
  ]))
}